<template lang="html">
  <transition name="dropdownx">
    <div
      v-if="dropdownVisible"
      ref="options"
      :class="{'rightx':msDropRight || $parent.rightx,'notHeight': notHeight,'show-arrow':!showArrow,'back-ground-white':showInputSearch}"
      :style="{
        'left':`${leftx + leftAfter}px`,
        'top':`${topx}px`,
        'z-index': zIndex + ' !important'
      }"
      class="con-ms-dropdown--menu ms-dropdown-menu"
      @mouseleave="mouseleavex"
      @mouseenter="mouseenterx"
    >
      <!-- @mouseout="toggleMenu($event)" -->
      <!-- @mouseover="toggleMenu($event)" -->
      <!-- Tìm kiếm -->
      <ms-input
      v-if="showInputSearch"
      icon="mi-search"
      :placeholder="$t('i18nCommon.Search')"
      v-model="searchInput"
      @keyup="onSearch"
      style="margin-bottom:4px;padding: 0px 8px;"
      @click.stop
      :autofocus="true"
      />
      <ul
        v-if="!msCustomContent"
        class="ms-component ms-dropdown--menu"
        :class="{'box-shadow-none':showInputSearch}">
        <slot/>
      </ul>
      <div
        v-else
        class="ms-dropdown--custom ms-dropdown--menu">
        <slot/>
      </div>
      <div
        ref="menuAfter"
        :class="[msDropRight ? 'ms-dropdown-right--menu--after' : 'ms-dropdown--menu--after']"
        :style="{right: !msDropRight ? 5 + leftAfter + 'px' : 0}"
      ></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "MsDropdownMenu",
  data: () => ({
    dropdownVisible: false,
    leftx: 0,
    topx: 0,
    rightx: true,
    msTriggerClick: false,
    msDropRight: false,
    widthx: 0,
    notHeight: false,
    msCustomContent: false,
    parentNode: null,
    searchInput:null
  }),
  watch:{
    dropdownVisible(val) {
      let dropdownGroup = this.$children.filter(item => item.hasOwnProperty('activeGroup'))
      dropdownGroup.forEach((item_group)=>{
        item_group.activeGroup = false
      })
      this.setDirection()

      !val ? this.$parent.rightx = false : null
      this.$emit("toggle", val);
    },
    isHideMsDropdown(val) {
        this.dropdownVisible = false;
    }
  },
  props: {
    //Show thanh tìm kiếm
    showInputSearch:{
      default: false,
      type: [String, Boolean]
    },
    isHideMsDropdown: {
      default: false,
      type: [String, Boolean]
    },
    leftAfter: {
      default: 0,
      type: Number
    },
    showArrow:{
      default: false,
      type: [String, Boolean]
    },
    zIndex:{
      default: 991,
      type: Number
    }
  },
  mounted() {
    this.insertBody()
  },
  beforeDestroy() {
    this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
  },
  methods:{
    /**
     * Emit sự kiện search
     * Created by tcduong 30.3.2021
     */
    onSearch(){
      this.$emit("onSearch",this.searchInput);
    },
    mouseenterx() {
      if (!this.msTriggerClick) {
        this.dropdownVisible = true
        this.widthx = this.$el.clientWidth
      }
    },
    mouseleavex() {
      if (!this.msTriggerClick) {
        this.dropdownVisible = false
        this.widthx = this.$el.clientWidth
      }
    },
    setDirection() {
      setTimeout(() => {
        const dropdown = this.parentNode
        const menuAfter = this.$refs.menuAfter
        if (!menuAfter) return
        if(dropdown && menuAfter && dropdown.getBoundingClientRect().top + 300 >= window.innerHeight) {
          // const hasGroup = this.$children.find(it=>it.hasOwnProperty('activeGroup'))
          menuAfter.style.bottom = '-5px'
          menuAfter.style.transform = 'rotate(225deg)'
          return
        }
        menuAfter.style.top = '10px'
      }, 100)
    },
    toggleMenu(event){
      if(event.type == 'mouseover' && !this.msTriggerClick){
        this.dropdownVisible = true
      }
      else if (!this.msTriggerClick) {
        this.dropdownVisible = false
      }
      this.widthx = this.$el.clientWidth
    },
    insertBody(){
      let elp = this.$el
      this.parentNode = this.$el.parentNode
      document.body.insertBefore(elp, document.body.firstChild)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/controls/msDropDown.scss";
.pd-lr-12 {
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.324px;
  color: #1f2023;
}
.ms-popup--close {
  font-size: 22px !important;
}
.back-ground-white{
  box-shadow: rgba(0, 0, 0, 0.176) 0px 1px 10px !important;
  background-color: #fff !important;
}
.box-shadow-none{
  box-shadow: none !important;
}
</style>
